import { useEffect } from "react";

export function useOnClickOutside(ref, handler, enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const listener = (event) => {
      // Ignore if clicking inside the referenced element
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      // Call the handler if clicking outside
      handler(event);
    };

    // Use capture phase so this runs before React's event system
    document.addEventListener("mousedown", listener, true);
    document.addEventListener("touchstart", listener, true);

    return () => {
      document.removeEventListener("mousedown", listener, true);
      document.removeEventListener("touchstart", listener, true);
    };
  }, [ref, handler, enabled]);
}